import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Input } from "@progress/kendo-react-inputs";
import Button from "../buttons/Button";
import "./Input.scss";

/**
 * Input component
 * @module
 * @param {string} [validationMessage] - Validation message if field is invalid
 * @param {string} name - Name
 * @param {bool} [required] - Is input required?
 * @param {func} onChange - Function invoked on value change
 * @param {(string | number)} [value] - Current value
 * @param {bool} [disabled] - Is input readonly?
 * @param {string} [type] - Type of input
 * @param {string} [placeholder] - Input placeholder
 * @param {func} [onClick] - Function invoked on click, if input has button
 * @param {bool} [autofocus] - Should input be focused?
 * @param {number} [minLength] - Minimum length
 * @param {number} [maxLength] - Maximum length
 * @param {string} [pattern] - Regex for validity check
 * @param {bool} [readOnly] - Read only
 * @param {number} [tabIndex] - Input tabindex
 * @param {bool} [isPicker] - Is picker
 * @param {func} [onBlur] - Function invoked on input blur
 * @param {string} [autoComplete] - HTML attribute: autocomplete
 */
const InputComponent = ({
  validationMessage,
  name,
  required,
  onChange,
  value,
  disabled,
  readOnly,
  type,
  placeholder,
  onClick,
  autofocus,
  minLength,
  maxLength,
  min,
  max,
  pattern,
  tabIndex,
  onBlur,
  valid,
  accept,
  // copyable,
  title,
  step,
  multiple,
  autoComplete
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleBlur = () => {
    if (onBlur) {
      onBlur();
    }
  };

  // const handleCopy = () => {
  //   navigator.clipboard.writeText(value);
  // };

  const handleOpenUrl = () => {
    window.open(value);
  };

  const handleChange = (e) => {
    const inputValue =
      type && type === "file" ? e.target._input : e.target.value;
    setInputValue(inputValue);
    onChange(name, inputValue);
  };

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  return (
    <>
      <Input
        className={`form-input input ${disabled ? "disabled-field" : required ? "required-field" : "default-field"}`}
        validationMessage={validationMessage || "Povinné"}
        required={required}
        onChange={handleChange}
        value={inputValue}
        // disabled={disabled && !copyable}
        type={type}
        placeholder={placeholder}
        onClick={onClick}
        autoFocus={autofocus}
        minLength={minLength}
        maxLength={maxLength}
        min={min}
        max={max}
        pattern={pattern}
        tabIndex={tabIndex}
        onBlur={handleBlur}
        readOnly={disabled || readOnly}
        valid={valid}
        accept={accept}
        title={title}
        step={step}
        multiple={multiple}
        autoComplete={autoComplete || "new-password"}
      />
      {/* {copyable && value &&
          <div className="copyable">
            <Button
              className="copyable-button"
              primary={true}
              icon="copy"
              onClick={this.handleCopy}
              disabled={false}
              title="Kopírovať text"
            />
          </div>
        } */}
      {type === "url" && value && (
        <div className="hyperlink">
          <Button
            className="hyperlink-button"
            primary={true}
            icon="hyperlink-open-sm"
            onClick={handleOpenUrl}
            disabled={false}
            title="Otvoriť url"
          />
        </div>
      )}
    </>
  );
};

InputComponent.propTypes = {
  validationMessage: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onClick: PropTypes.func,
  autofocus: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  pattern: PropTypes.string,
  tabIndex: PropTypes.number,
  isPicker: PropTypes.bool,
  onBlur: PropTypes.func,
  valid: PropTypes.bool,
  accept: PropTypes.string,
  title: PropTypes.string,
  step: PropTypes.string,
  multiple: PropTypes.bool,
  autoComplete: PropTypes.string
};

export default InputComponent;
